import { MaterialReactTable } from 'material-react-table';
import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/terminals-controller';

export const TerminalsRoute = () => {
    const { tableSettings } = useController();

    return (
        <OWContainer>
            <MaterialReactTable table={tableSettings} />
        </OWContainer>
    );
};
